import React from 'react';
import { get } from 'lodash-es';
import { string } from 'prop-types';
import axios from 'axios';

import {
  CSRF_TOKEN,
  metaLoading,
} from '../../lib/helpers';

import Loading from '.././Loading';
import Quota from './Quota';

class QuotaOverview extends React.Component {
  static propTypes = {
    path: string.isRequired
  }

  state = {
    ...metaLoading,
    quotas: []
  }

  componentDidMount() {
    this.setState({ meta: { isLoading: true } })

    axios.get(this.props.path)
      .then((res) => {
        const quotas = get(res, 'data')
        if(res.status == 200 && quotas) {
          this.setState({ quotas: quotas.filter(quota => quota.actions.length > 0), meta: { isLoading: false } })
        }
      })
  }

  updateQuota(key, action, count) {
    axios.put(`${this.props.path}/${action}`, {
      authenticity_token: CSRF_TOKEN,
      counts: { [key]: count }
    }).then(() => location.reload())
  }

  clearQuota(action) {
    axios.delete(`${this.props.path}/${action}`, {
      data: { authenticity_token: CSRF_TOKEN }
    }).then(() => location.reload())
  }

  render = () => {
    const { quotas } = this.state
    return (
      <Loading isLoading={get(this.state, 'meta.isLoading')}>
        {quotas.map((quota) => {
          return (
            <Quota
              key={quota.name}
              name={quota.name}
              actions={quota.actions}
              updateQuota={(action, count) => this.updateQuota(quota.key, action, count)}
              clearQuota={(action) => this.clearQuota(action)}
            />
          )
        })}
      </Loading>
    )
  }
}

export default QuotaOverview;
